<section class="ui-section">
  <header class="ui-section-header">
    <span class="ui-section-copy">
      @if (hasEyebrow()) {
        <span class="ui-section-eyebrow">{{ eyebrow() }}</span>
      }
      <span class="ui-section-title">{{ title() }}</span>
      @if (hasDescription()) {
        <span class="ui-section-description">{{ description() }}</span>
      }
    </span>
    @if (hasAction()) {
      <button
        class="ui-section-action"
        type="button"
        (click)="handleActionRequested()"
      >
        {{ actionLabel() }}
      </button>
    }
  </header>
  <div class="ui-section-body">
    <ng-content />
  </div>
</section>
